import gaObjectName from './object-name';

export const isActive = Boolean(gaObjectName in window);

export default (...args) => isActive ? window[gaObjectName](...args) : false;
